/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import Link from '@components/link'
import { CtaArrow, JsonLd } from '@components/atoms'
import Typography from '@material-ui/core/Typography'
import { IconMarker } from '@components/atoms/icons'

import useStyles from './card-course.styles'

const CardCourse = React.memo((props) => {
  const {
    name,
    photoFacility,
    zip,
    city,
    state,
    address1,
  } = props

  const s = useStyles()
  return (
    <Link {...props}>

      <div className={s.course}>
        <JsonLd {...{
          '@type': 'GolfCourse',
          name,
          address: {
            '@type': 'PostalAddress',
            streetAddress: address1,
            addressLocality: city,
            addressRegion: state,
            postalCode: zip,
            addressCountry: 'United States',
          },
        }}
        />
        {photoFacility && (
          <div
            className={s.image}
            style={{ backgroundImage: `url(${photoFacility}?w=400&h=360)` }}
            role="img"
            aria-label={`${name} photo`}
          />
        )}

        <div className={s.content}>
          <div className={s.col}>
            <Typography
              variant="h5"
              gutterBottom
              data-testid="course-name"
            >
              {name}
            </Typography>
            <div className={s.location}>
              <IconMarker className={s.icon} />
              <div className={s.address}>
                {address1} <br />
                {city}, {state} {zip}
              </div>
            </div>
          </div>
          <div className={s.ctaCol}>
            <CtaArrow color="black" className={s.cta} />
          </div>
        </div>

      </div>

    </Link>
  )
})

CardCourse.propTypes = {
  name: PropTypes.string,
  link: PropTypes.string,
  slug: PropTypes.string,
  zip: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  address1: PropTypes.string,
  facility_id: PropTypes.string,
  photoFacility: PropTypes.string,
}

export default CardCourse
